import React from "react";
import useTopic from "@livepix/components/pubsub/useTopic";
import useNotifications, { NotificationEvent } from "./useNotifications";
import Widget from "../Widget";

const NotificationWidgetEmbed = (props: {
  userId: string;
  widgetId: string;
}) => {
  const {
    identifier,
    notification,
    visible,
    willDisappear,
    showNotification,
    hideNotification,
    playNotification,
  } = useNotifications();

  useTopic(`widget:${props.widgetId}`, (message) => {
    switch (message.event) {
      case "reload":
        window.location.reload();
        break;
      case "notification:show":
        showNotification(message.payload as NotificationEvent);
        break;
      case "notification:skip":
        hideNotification(0);
        break;
    }
  });

  useTopic(`user:widgets:notification:${props.userId}`, (message) => {
    switch (message.event) {
      case "reload":
        window.location.reload();
        break;
      case "notification:skip":
        hideNotification(0);
        break;
    }
  });

  if (notification) {
    return (
      <Widget
        key={identifier}
        visible={visible}
        willDisappear={willDisappear}
        onReady={() => playNotification()}
        {...notification}
      />
    );
  }

  return null;
};

export default NotificationWidgetEmbed;
